module.exports = "<div class=\"header\">\r\n  <div class=\"back-button\" (click)=\"this.close.emit($event); goToBegin();\" ><i class=\"fa fa-angle-left\"></i></div>\r\n  <div class=\"title\">{{this.title}}</div>\r\n  <div class=\"extra-function\">\r\n    <ng-container  *ngIf=\"this.currentComponent\">\r\n      <ng-container *ngComponentOutlet=\"this.currentComponent\"></ng-container>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/Components/header/header.component.html
// module id = ../../../../../src/app/Components/header/header.component.html
// module chunks = 1